import React from 'react';
import BuildIcon from '@material-ui/icons/Build';
import { Button } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { rebuildSourceFile } from '../../../redux/actions/manageAssetActions';
import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
	textTransformNone: {
		textTransform: 'none',
	},
}));
// Rebuild source file Btn
const FileRebuildBtn = ({ asset, srcFile }) => {
	const dispatch = useDispatch();
	const classes = useStyles();
	const handleClick = () => {
		dispatch(rebuildSourceFile(srcFile, asset));
	};
	return (
		<div>
			<Button
				color="primary"
				size="large"
				onClick={handleClick}
				startIcon={<BuildIcon />}
				className={classes.textTransformNone}
			>
				Rebuild
			</Button>
		</div>
	);
};

export default FileRebuildBtn;
